import { IconX } from "@tabler/icons-react"; 
import TextareaField from "../../../components/common/TextareaField";

export default function ReverseOrderModal({
  onClose,
}: {
  onClose: () => void;
}) {
  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-[#F7F6F2] rounded-2xl ">
        <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2]">
          <h2 className="text-2xl">Create Reverse Order </h2>
          <button
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
            onClick={onClose}
          >
            <IconX size={24} />
          </button>
        </div>

        <div className="w-[655px] p-4 space-y-4">
          <TextareaField
            name='awbNumber'
          rows={5}
            label={"Enter AWB Number"}
            placeholder={"Enter AWB Number"}
          />
        </div>

        <div className="border-t border-[#D8D8D8] px-4 py-4 flex justify-end space-x-2">
          <button
            className="border border-[#D8D8D8]  bg-transparent flex items-center rounded-full p-2 px-4 space-x-1 cursor-pointer text-base font-medium "
            onClick={onClose}
          >
            Cancel
          </button>
          <button className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
